import { Field } from 'formik';
import React from 'react';
import { useSelector } from 'react-redux';

import { useLocalization } from 'redux/localization/utils/hooks';

import InputField from './InputField';

// eslint-disable-next-line import/no-cycle
import { normalizeInteger } from './index';

const BirthDate = ({
  isRequired = true,
  showAgeVerificationMessage = true
}) => {
  const setting = useSelector((state) => state.setting.data);
  const { t } = useLocalization();

  const { defaultCountryCode } = setting;

  return (
    <div className="c7-form__group c7-form--birth-date">
      <span className="c7-label" aria-describedby="c7-birthDate-help">
        {t('general.address.birthDate')}
      </span>
      <span className="c7-break" aria-hidden="true" />
      {defaultCountryCode === 'US' && (
        <>
          <Field
            label={t('general.address.month')}
            component={InputField}
            required={isRequired}
            type="text"
            name="birthMonth"
            placeholder="MM"
            autocomplete="bday-month"
            maxLength="2"
            inputMode="decimal"
            normalize={normalizeInteger}
          />
          <Field
            label={t('general.address.day')}
            component={InputField}
            required={isRequired}
            type="text"
            name="birthDay"
            placeholder="DD"
            autocomplete="bday-day"
            maxLength="2"
            inputMode="decimal"
            normalize={normalizeInteger}
          />
        </>
      )}
      {defaultCountryCode !== 'US' && (
        <>
          <Field
            label={t('general.address.day')}
            component={InputField}
            required={isRequired}
            type="text"
            name="birthDay"
            placeholder="DD"
            autocomplete="bday-day"
            maxLength="2"
            inputMode="decimal"
            normalize={normalizeInteger}
          />
          <Field
            label={t('general.address.month')}
            component={InputField}
            required={isRequired}
            type="text"
            name="birthMonth"
            placeholder="MM"
            autocomplete="bday-month"
            maxLength="2"
            inputMode="decimal"
            normalize={normalizeInteger}
          />
        </>
      )}
      <Field
        label={t('general.address.year')}
        component={InputField}
        required={isRequired}
        type="text"
        name="birthYear"
        placeholder="YYYY"
        autocomplete="bday-year"
        maxLength="4"
        inputMode="decimal"
        normalize={normalizeInteger}
      />
      <span className="c7-break" aria-hidden="true" />
      {showAgeVerificationMessage && (
        <p className="c7-form__help" id="c7-birthDate-help">
          {t('general.address.ageVerificationDescription')}
        </p>
      )}
    </div>
  );
};

export default BirthDate;
